import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as R from 'ramda'
import moment from 'moment'
import calculatePerformance from './calculatePerformance'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
		studentPerformance: {
			schoolResult: {}
		},
		teacherPerformance: {},
		schoolPerformance: {},
		reportMonth: '',
		progress: 0
  },
  mutations: {
		setSchoolPerformance(state, data) {
			state.schoolPerformance = data
		},
		setReportMonth(state, reportMonth) {
			state.reportMonth = reportMonth
		},
		setProgress(state, percentage){
			state.progress = percentage
		}
	},
	getters: {
		topTeachers(state) {
			return calculatePerformance.topTeachers(state.schoolPerformance)
		},
		topStudents(state) {
			return calculatePerformance.topStudents(state.schoolPerformance)
		},
		topClasses(state) {
			return calculatePerformance.topClasses(state.schoolPerformance)
		},
		pointsByClass(state) {
			return calculatePerformance.pointsByClass(state.schoolPerformance)
		},
		totalScans(state) {
			return calculatePerformance.totalScans(state.schoolPerformance)
		},
		totalPoints(state) {
			return calculatePerformance.totalPoints(state.schoolPerformance)
		},
		behaviours(state) {
			return calculatePerformance.behaviours(state.schoolPerformance)
		}
	},
	actions: {
		'load.annual'(context, { schoolID, label } = {}) {
			context.commit("setSchoolPerformance",{})
			return axios.get(`http://localhost:3000/${schoolID}`).then(res => {
				context.commit("setReportMonth", label || "YEAR 2020")
				context.commit("setSchoolPerformance", {
					...res.data.result,
				})
			})
		},
		async 'load'(context, { schoolID, year, month } = {}) {
			const date = moment(`${month}-${year}`, 'M-YYYY')
			if (!date.isValid()) {
				throw 404
			}

			const reportMonth = date.format('MMMM YYYY')
			context.commit("setSchoolPerformance", {})
			context.commit("setReportMonth", reportMonth)
			
			context.commit('setProgress',0)
			const [a,b,c] = await Promise.all([
				axios.post('https://api.studentqr.com/api/reportsV2/generate/school', { schoolID, year, month }).then(res => {
					context.commit('setProgress', context.state.progress + 1)
					return res.data
				}),
				axios.post('https://api.studentqr.com/api/reportsV2/generate/teacher', { schoolID, year, month }).then(res => {
					context.commit('setProgress', context.state.progress + 1)
					return res.data
				}),
				axios.post('https://api.studentqr.com/api/reportsV2/generate/kelas', { schoolID, year, month }).then(res => {
					context.commit('setProgress', context.state.progress + 1)
					return res.data
				})
			]);
			
			context.commit("setSchoolPerformance", {
				...a.result,
				...b.result,
				...c,
				reportMonth,
			})
			
		},
		'school.load'(context, { schoolID, year, month } = {}) {
			const reportMonth = moment(`${month}-${year}`, 'M-YYYY').format('MMMM YYYY')
			context.commit("setSchoolPerformance",{})
			context.commit("setReportMonth", reportMonth)
			
			return axios.post('https://api.studentqr.com/api/reports/generate', { schoolID, year, month }).then(res => {
				context.commit("setSchoolPerformance", {
					...res.data.result,
					reportMonth,
				})
			})
		}
  }
})
